module.exports = __webpack_public_path__ + "img/compact_disc_gold.c5a28496.svg";